var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxtf-row",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "yxtbiz-knginfo font-size-14",
      attrs: { gutter: 40 },
    },
    [
      _c(
        "yxtf-col",
        { staticClass: "font-size-16 lh24", attrs: { span: 24 } },
        [_vm._v(_vm._s(_vm.$t("biz_lbl_knginfo" /** 知识信息 */)))]
      ),
      _vm._l(_vm.colList, function (item) {
        return _c(
          "yxtf-col",
          { key: item.key, staticClass: "mt24 nowrap", attrs: { span: 12 } },
          [
            _c("label", { staticClass: "pull-left color-gray-7" }, [
              _vm._v(_vm._s(item.label) + "："),
            ]),
            _c(
              "yxtf-tooltip",
              {
                attrs: {
                  "open-filter": "",
                  content: item.value,
                  placement: "top",
                },
              },
              [
                _c("div", { staticClass: "nowrap ellipsis" }, [
                  _vm._v(_vm._s(item.value)),
                ]),
              ]
            ),
          ],
          1
        )
      }),
      _c(
        "yxtf-col",
        { staticClass: "mt24", attrs: { span: 24 } },
        [
          _c(
            "yxtf-link",
            {
              attrs: { type: "primary", underline: false },
              on: { click: _vm.openDetail },
            },
            [_vm._v(_vm._s(_vm.$t("biz_lbl_previewkng" /** 查看知识详情 */)))]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }